import { h, Component } from 'preact';
import 'store/bolt/cookies';
import { accessNested, joinClasses } from 'utils/utils';
import { getValueForClientSize } from 'utils/bolt';
import Store from 'store/store';
import Button from 'components/bolt/button/button';
import Chevron from 'components/bolt/icons/chevron';
import HTML from 'components/core/html/html';
import s from 'components/bolt/ageGate/ageGate.sss';
// import Cookies from 'js-cookie';
// const POWSTER_COOKIE = 'pow-cookie-cats-';

const pad2 = n => ('0' + n).slice(-2);

function parse(str) {
	if (str.length) {
		return +str;
	}
	return null;
}

export default class AgeGate extends Component {
	constructor(props) {
		super(props);

		this.state = {};
		this.checkAge = this.checkAge.bind(this);
		this.handleMouseDown = this.handleMouseDown.bind(this);
		
	}

	componentDidMount() {
		document.addEventListener('mousedown', this.handleMouseDown, false);
		if (this.props.appData?.options.ageGate?.lockOut && (Store.get().client.ofAge === false)) {
			this.setState({ lockedOut: true });
		}
	}

	componentWillUnmount() {
		document.removeEventListener('mousedown', this.handleMouseDown, false);
	}

	handleMouseDown(e) {
		e.stopPropagation();
		e.interactivity = true;
	}

	renderYearOptions() {
		const currentYear = new Date().getFullYear();
		return [...Array(120)].map((e, i) => {
			let year = currentYear - i;
			return <option value={year} key={year}>{year}</option>;
		});
	}


	checkAge(event) {
		if (event && typeof event.preventDefault === 'function') {
			event.preventDefault();
		}

		let { day, month, year } = this.state;

		if (!day || !(month || month === 0) || !year) {
			return;
		}

		const minAge = +accessNested(this.props, 'appData.options.ageGate.consentAge', 18);
		let now = new Date();
		let allowedFrom = new Date((+year) + minAge, (+month), (+day));
		let permitted = now >= allowedFrom;

		Store.emit('AGEGATE_CONSENT', permitted);
		const lockOut = this.props.appData?.options.ageGate.lockOut;

		if (!lockOut || permitted) {
			Store.emit('AGEGATE_CLOSE');
		} else {
			this.setState({ lockedOut: true });
		}
	}

	render() {
		const { copy, isSectionAgeGate, appData } = this.props;
		const { lockedOut } = this.state;
		const minAge = appData.options.ageGate?.consentAge || 18;

		let {
			$AGE_GATE_DESCRIPTION = 'To make sure we offer you best experience we must know if you are of legal age.',
			$AGE_GATE_INSTRUCTION = 'Please enter your birth date to continue',
			$AGE_GATE_CONFIRM = 'Confirm',
			$PRIVACY = 'Privacy Policy',
			$AGE_GATE_ACCESS_DENIED = 'Apologies, this content is for users over %MIN_AGE% only.'
		} = copy.baseCopy;

		$AGE_GATE_ACCESS_DENIED = $AGE_GATE_ACCESS_DENIED.replace('%MIN_AGE%', minAge);

		$AGE_GATE_DESCRIPTION = $AGE_GATE_DESCRIPTION.replace(/%PRIVACY%/g, $PRIVACY);

		const fontStyles = accessNested(this.props, 'appData.styling.fontVariables');

		const useShort = this.props.labels === 'short';
		let monthLabels = accessNested(copy, '$DATETIME_LOCALE.$MONTHS_FULL');
		if (useShort || !monthLabels) {
			monthLabels = [...Array(12)].map((e, i) => pad2(i + 1));
		}

		const tt = accessNested(this.props, 'appData.pages.boltHome.data.tt', {});
		const ttOverride = appData.options?.ageGate?.image;

		let ttSrc = null;
		if (tt.desktop || tt.tablet || tt.mobile) {
			ttSrc = ttOverride || getValueForClientSize(tt, null, { nullIfDisabled: true });
		}

		let labelDay = accessNested(copy, 'baseCopy.$DATETIME_LOCALE.$LABEL_DAY') || 'Day';
		const labelShortDay = accessNested(copy, 'baseCopy.$DATETIME_LOCALE.$LABEL_SHORT_DAY') || 'DD';
		let labelMonth = accessNested(copy, 'baseCopy.$DATETIME_LOCALE.$LABEL_MONTH') || 'Month';
		const labelShortMonth = accessNested(copy, 'baseCopy.$DATETIME_LOCALE.$LABEL_SHORT_MONTH') || 'MM';
		let labelYear = accessNested(copy, 'baseCopy.$DATETIME_LOCALE.$LABEL_YEAR') || 'Year';
		const labelShortYear = accessNested(copy, 'baseCopy.$DATETIME_LOCALE.$LABEL_SHORT_YEAR') || 'YYYY';

		labelDay = labelDay.charAt(0).toUpperCase() + labelDay.slice(1);
		labelMonth = labelMonth.charAt(0).toUpperCase() + labelMonth.slice(1);
		labelYear = labelYear.charAt(0).toUpperCase() + labelYear.slice(1);

		return (
			<div class={isSectionAgeGate && s.sectionAgeGate}>
				<div class={s.screenCover} />
				<div class={s.screenContainer}>
					<div class={s.container}>
						<div class={s.top}>
							<img
								src={ttSrc}
								class={joinClasses(s.tt)}
								alt={copy.accessibilityCopy[tt.alt] || tt.alt}
							/>
							{!lockedOut && (
								<HTML markdown class={joinClasses(s.description, fontStyles.prefCentreDescription)}>
									{$AGE_GATE_DESCRIPTION}
								</HTML>
							)}
						</div>
						<div class={joinClasses(s.middle, lockedOut && s.lockedOut)}>
							{!lockedOut && (
								<form class={s.wrapper} onSubmit={this.checkAge}>
									<fieldset>
										<HTML markdown class={s.instruction}>
											{$AGE_GATE_INSTRUCTION}
										</HTML>
										<div class={s.inputs}>
											<div class={s.selectWrapper}>
												<select
													onChange={(e) => this.setState({ day: parse(e.target.value) })}
													class={s.input}
													ref={e => this.$day = e}
													required
												>
													<option value="">{useShort ? labelShortDay : labelDay}</option>
													{[...Array(31)].map((e, i) => <option value={i + 1} key={i + 1}>{pad2(i + 1)}</option>)}
												</select>
												<Chevron class={s.chevron} />
											</div>
											<div class={s.selectWrapper}>
												<select
													onChange={(e) => this.setState({ month: parse(e.target.value) })}
													class={s.input}
													ref={e => this.$month = e}
													required
												>
													<option value="">{useShort ? labelShortMonth : labelMonth}</option>
													{[...Array(12)].map((e, i) => <option value={i} key={i}>{monthLabels[i]}</option>)}
												</select>
												<Chevron class={s.chevron} />
											</div>
											<div class={s.selectWrapper}>
												<select
													onChange={(e) => this.setState({ year: parse(e.target.value) })}
													class={s.input}
													ref={e => this.$year = e}
													required
												>
													<option value="">{useShort ? labelShortYear : labelYear}</option>
													{this.renderYearOptions(useShort)}
												</select>
												<Chevron class={s.chevron} />
											</div>
										</div>
									</fieldset>
								</form>
							)}
							{lockedOut && (
								<div class={s.error}>
									{$AGE_GATE_ACCESS_DENIED}
								</div>
							)}
						</div>
						{!lockedOut && (
							<div class={s.bottom}>
								<Button
									disabled={!(this.state.day && (this.state.month || this.state.month === 0) && this.state.year)}
									type="primary"
									class={joinClasses(s.save, fontStyles.prefCentreSaveBtn)}
									trigger={this.checkAge}
								>
									{$AGE_GATE_CONFIRM}
								</Button>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}
